import { render, staticRenderFns } from "./InstallInstructions.vue?vue&type=template&id=4fbed1c1&"
import script from "./InstallInstructions.vue?vue&type=script&lang=js&"
export * from "./InstallInstructions.vue?vue&type=script&lang=js&"
import style0 from "./InstallInstructions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports